import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import MosaicVentures from './components/mosaicventures';
import PrivacyPolicy from './components/privacypolicy';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Main Landing Page Root Route */}
          <Route path="/" element={<MosaicVentures />} />
          
          {/* Privacy Policy Route */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};

export default App;